import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_EMAILS = ['clubdocupom.com@gmail.com', 'donato.coutinho@gmail.com'];

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const session_token = params.get('session_token');

        if (!session_token) {
          // No token in hash - check existing session
          const existing = localStorage.getItem('session_token');
          if (existing) {
            try {
              const res = await axios.get(`${BACKEND_URL}/api/auth/me`, {
                headers: { Authorization: `Bearer ${existing}` }
              });
              navigateByRole(res.data);
              return;
            } catch {
              localStorage.removeItem('session_token');
            }
          }
          navigate('/');
          return;
        }

        // Clean hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Store token and fetch user data
        localStorage.setItem('session_token', session_token);

        const res = await axios.get(`${BACKEND_URL}/api/auth/me`, {
          headers: { Authorization: `Bearer ${session_token}` }
        });

        navigateByRole(res.data);
      } catch (err) {
        console.error('Auth processing failed:', err);
        localStorage.removeItem('session_token');
        setError('Falha na autenticação. Tente novamente.');
      }
    };

    const navigateByRole = (user) => {
      if (!user) { navigate('/'); return; }
      const isAdmin = ADMIN_EMAILS.includes(user.email);
      if (!isAdmin && (!user.role || !user.city)) {
        navigate('/setup', { state: { user } });
      } else if (isAdmin) {
        navigate('/admin', { state: { user } });
      } else if (user.role === 'influencer') {
        navigate('/influencer', { state: { user } });
      } else if (user.role === 'merchant') {
        navigate('/merchant', { state: { user } });
      } else {
        navigate('/dashboard', { state: { user } });
      }
    };

    processAuth();
  }, [navigate]);

  const handleRetry = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `${BACKEND_URL}/api/auth/google/login?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-center max-w-sm mx-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <p className="text-red-700 font-medium mb-4" data-testid="auth-error-msg">{error}</p>
            <button onClick={handleRetry}
              className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-2 px-6 rounded-lg transition-all"
              data-testid="auth-retry-btn">
              Tentar Novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-slate-500"></div>
        <p className="mt-4 text-slate-600">Autenticando...</p>
      </div>
    </div>
  );
}
